function generateIconStyles(version) {
    return `@font-face {
    font-family: drycons;
    src: url(https://cdn.drawbotics.com/drycons/#{version}/drycons.eot);
    src: url(https://cdn.drawbotics.com/drycons/#{version}/drycons.eot?#iefix) format("embedded-opentype"), url(https://cdn.drawbotics.com/drycons/#{version}/drycons.woff2) format("woff2"), url(https://cdn.drawbotics.com/drycons/#{version}/drycons.woff) format("woff"), url(https://cdn.drawbotics.com/drycons/#{version}/drycons.ttf) format("truetype"), url(https://cdn.drawbotics.com/drycons/#{version}/drycons.svg#drycons) format("svg");
    font-style: normal;
    font-weight: 400;
}

.Drycon {
    display: inline-block;
    transform: translate(0, 0);
    text-rendering: auto;
    font: normal normal 400 14px/1 drycons;
    font-size: 18px; font-family: drycons !important;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

.Drycon-lg {
    vertical-align: -15%;
    line-height: 0.75em;
    font-size: 1.33333333em;
}

.Drycon-2x {
    font-size: 2em;
}

.Drycon-3x {
    font-size: 3em;
}

.Drycon-4x {
    font-size: 4em;
}

.Drycon-5x {
    font-size: 5em;
}

.Drycon-fw {
    width: 1.28571429em;
    text-align: center;
}

.Drycon-activity::before {
    content: "\\ea01";
}

.Drycon-airplay::before {
    content: "\\ea02";
}

.Drycon-alert-circle::before {
    content: "\\ea03";
}

.Drycon-alert-octagon::before {
    content: "\\ea04";
}

.Drycon-alert-triangle::before {
    content: "\\ea05";
}

.Drycon-align-center::before {
    content: "\\ea06";
}

.Drycon-align-justify::before {
    content: "\\ea07";
}

.Drycon-align-left::before {
    content: "\\ea08";
}

.Drycon-align-right::before {
    content: "\\ea09";
}

.Drycon-anchor::before {
    content: "\\ea0a";
}

.Drycon-aperture::before {
    content: "\\ea0b";
}

.Drycon-arrow-down::before {
    content: "\\ea0c";
}

.Drycon-arrow-down-left::before {
    content: "\\ea0d";
}

.Drycon-arrow-down-right::before {
    content: "\\ea0e";
}

.Drycon-arrow-left::before {
    content: "\\ea0f";
}

.Drycon-arrow-right::before {
    content: "\\ea10";
}

.Drycon-arrow-up::before {
    content: "\\ea11";
}

.Drycon-arrow-up-and-down::before {
    content: "\\ea12";
}

.Drycon-arrow-up-left::before {
    content: "\\ea13";
}

.Drycon-arrow-up-right::before {
    content: "\\ea14";
}

.Drycon-at-sign::before {
    content: "\\ea15";
}

.Drycon-awaiting::before {
    content: "\\ea16";
}

.Drycon-award::before {
    content: "\\ea17";
}

.Drycon-balcony::before {
    content: "\\ea18";
}

.Drycon-bar-chart::before {
    content: "\\ea19";
}

.Drycon-bar-chart-2::before {
    content: "\\ea1a";
}

.Drycon-bathroom::before {
    content: "\\ea1b";
}

.Drycon-battery::before {
    content: "\\ea1c";
}

.Drycon-battery-charging::before {
    content: "\\ea1d";
}

.Drycon-bedroom::before {
    content: "\\ea1e";
}

.Drycon-bell::before {
    content: "\\ea1f";
}

.Drycon-bell-off::before {
    content: "\\ea20";
}

.Drycon-billboard::before {
    content: "\\ea21";
}

.Drycon-billing::before {
    content: "\\ea22";
}

.Drycon-bluetooth::before {
    content: "\\ea23";
}

.Drycon-bold::before {
    content: "\\ea24";
}

.Drycon-book::before {
    content: "\\ea25";
}

.Drycon-bookmark::before {
    content: "\\ea26";
}

.Drycon-box::before {
    content: "\\ea27";
}

.Drycon-brand-id::before {
    content: "\\ea28";
}

.Drycon-briefcase::before {
    content: "\\ea29";
}

.Drycon-briefing::before {
    content: "\\ea2a";
}

.Drycon-brochure::before {
    content: "\\ea2b";
}

.Drycon-budget::before, .Drycon-money-bag::before {
    content: "\\ea2c";
}

.Drycon-building::before {
    content: "\\ea2d";
}

.Drycon-calculator::before {
    content: "\\ea2e";
}

.Drycon-calendar::before {
    content: "\\ea2f";
}

.Drycon-camera::before {
    content: "\\ea30";
}

.Drycon-camera-off::before {
    content: "\\ea31";
}

.Drycon-cast::before {
    content: "\\ea32";
}

.Drycon-check::before {
    content: "\\ea33";
}

.Drycon-check-circle::before {
    content: "\\ea34";
}

.Drycon-check-square::before {
    content: "\\ea35";
}

.Drycon-chevron-down::before {
    content: "\\ea36";
}

.Drycon-chevron-left::before {
    content: "\\ea37";
}

.Drycon-chevron-right::before {
    content: "\\ea38";
}

.Drycon-chevron-up::before {
    content: "\\ea39";
}

.Drycon-chevrons-down::before {
    content: "\\ea3a";
}

.Drycon-chevrons-left::before {
    content: "\\ea3b";
}

.Drycon-chevrons-right::before {
    content: "\\ea3c";
}

.Drycon-chevrons-up::before {
    content: "\\ea3d";
}

.Drycon-chrome::before {
    content: "\\ea3e";
}

.Drycon-circle::before {
    content: "\\ea3f";
}

.Drycon-classification::before {
    content: "\\ea40";
}

.Drycon-clipboard::before {
    content: "\\ea41";
}

.Drycon-clock::before {
    content: "\\ea42";
}

.Drycon-cloud::before {
    content: "\\ea43";
}

.Drycon-cloud-drizzle::before {
    content: "\\ea44";
}

.Drycon-cloud-lightning::before {
    content: "\\ea45";
}

.Drycon-cloud-off::before {
    content: "\\ea46";
}

.Drycon-cloud-rain::before {
    content: "\\ea47";
}

.Drycon-cloud-snow::before {
    content: "\\ea48";
}

.Drycon-codepen::before {
    content: "\\ea49";
}

.Drycon-coffee::before {
    content: "\\ea4a";
}

.Drycon-command::before {
    content: "\\ea4b";
}

.Drycon-commercial-floorplan::before {
    content: "\\ea4c";
}

.Drycon-compare::before {
    content: "\\ea4d";
}

.Drycon-compass::before {
    content: "\\ea4e";
}

.Drycon-conversation::before {
    content: "\\ea4f";
}

.Drycon-copy::before {
    content: "\\ea50";
}

.Drycon-corner-down-left::before {
    content: "\\ea51";
}

.Drycon-corner-down-right::before {
    content: "\\ea52";
}

.Drycon-corner-left-down::before {
    content: "\\ea53";
}

.Drycon-corner-left-up::before {
    content: "\\ea54";
}

.Drycon-corner-right-down::before {
    content: "\\ea55";
}

.Drycon-corner-right-up::before {
    content: "\\ea56";
}

.Drycon-corner-up-left::before {
    content: "\\ea57";
}

.Drycon-corner-up-right::before {
    content: "\\ea58";
}

.Drycon-correction-round::before {
    content: "\\ea59";
}

.Drycon-cosy-style::before {
    content: "\\ea5a";
}

.Drycon-cpu::before {
    content: "\\ea5b";
}

.Drycon-credit::before {
    content: "\\ea5c";
}

.Drycon-credit-card::before {
    content: "\\ea5d";
}

.Drycon-crop::before {
    content: "\\ea5e";
}

.Drycon-crosshair::before {
    content: "\\ea5f";
}

.Drycon-delete::before {
    content: "\\ea60";
}

.Drycon-disc::before {
    content: "\\ea61";
}

.Drycon-download::before {
    content: "\\ea62";
}

.Drycon-download-cloud::before {
    content: "\\ea63";
}

.Drycon-drag-and-drop::before {
    content: "\\ea64";
}

.Drycon-drawbotics::before {
    content: "\\ea65";
}

.Drycon-drone-shoot::before, .Drycon-drone-shooting::before {
    content: "\\ea66";
}

.Drycon-droplet::before {
    content: "\\ea67";
}

.Drycon-edit::before {
    content: "\\ea68";
}

.Drycon-edit-2::before {
    content: "\\ea69";
}

.Drycon-edit-3::before {
    content: "\\ea6a";
}

.Drycon-exterior-3d::before {
    content: "\\ea6b";
}

.Drycon-exterior-restyling::before {
    content: "\\ea6c";
}

.Drycon-external-link::before {
    content: "\\ea6d";
}

.Drycon-eye::before {
    content: "\\ea6e";
}

.Drycon-eye-off::before {
    content: "\\ea6f";
}

.Drycon-facebook::before {
    content: "\\ea70";
}

.Drycon-fast-forward::before {
    content: "\\ea71";
}

.Drycon-feather::before {
    content: "\\ea72";
}

.Drycon-file::before {
    content: "\\ea73";
}

.Drycon-file-minus::before {
    content: "\\ea74";
}

.Drycon-file-plus::before {
    content: "\\ea75";
}

.Drycon-file-text::before {
    content: "\\ea76";
}

.Drycon-film::before {
    content: "\\ea77";
}

.Drycon-filter::before {
    content: "\\ea78";
}

.Drycon-filter-filled::before {
    content: "\\ea79";
}

.Drycon-fire::before {
    content: "\\ea7a";
}

.Drycon-flag::before {
    content: "\\ea7b";
}

.Drycon-flyer::before {
    content: "\\ea7c";
}

.Drycon-folder::before {
    content: "\\ea7d";
}

.Drycon-furnished::before {
    content: "\\ea7e";
}

.Drycon-furnished-off::before {
    content: "\\ea7f";
}

.Drycon-gallery::before {
    content: "\\ea80";
}

.Drycon-garden::before {
    content: "\\ea81";
}

.Drycon-github::before {
    content: "\\ea82";
}

.Drycon-gitlab::before {
    content: "\\ea83";
}

.Drycon-globe::before {
    content: "\\ea84";
}

.Drycon-grid::before {
    content: "\\ea85";
}

.Drycon-hallway::before {
    content: "\\ea86";
}

.Drycon-hanger::before {
    content: "\\ea87";
}

.Drycon-hash::before {
    content: "\\ea88";
}

.Drycon-headphones::before {
    content: "\\ea89";
}

.Drycon-heart::before {
    content: "\\ea8a";
}

.Drycon-heart-broken::before {
    content: "\\ea8b";
}

.Drycon-heart-filled::before {
    content: "\\ea8c";
}

.Drycon-help-circle::before {
    content: "\\ea8d";
}

.Drycon-home::before {
    content: "\\ea8e";
}

.Drycon-house::before {
    content: "\\ea8f";
}

.Drycon-house-high::before {
    content: "\\ea90";
}

.Drycon-house-low::before {
    content: "\\ea91";
}

.Drycon-image::before {
    content: "\\ea92";
}

.Drycon-inbox::before {
    content: "\\ea93";
}

.Drycon-industrial-style::before {
    content: "\\ea94";
}

.Drycon-info::before {
    content: "\\ea95";
}

.Drycon-insights::before, .Drycon-data-points::before {
    content: "\\ea96";
}

.Drycon-instagram::before {
    content: "\\ea97";
}

.Drycon-interior-3d::before {
    content: "\\ea98";
}

.Drycon-invoice::before {
    content: "\\ea99";
}

.Drycon-italic::before {
    content: "\\ea9a";
}

.Drycon-key::before {
    content: "\\ea9b";
}

.Drycon-kitchen::before {
    content: "\\ea9c";
}

.Drycon-landing::before, .Drycon-landing-page::before {
    content: "\\ea9d";
}

.Drycon-layers::before {
    content: "\\ea9e";
}

.Drycon-layout::before {
    content: "\\ea9f";
}

.Drycon-life-buoy::before {
    content: "\\eaa0";
}

.Drycon-light-bulb::before {
    content: "\\eaa1";
}

.Drycon-link::before {
    content: "\\eaa2";
}

.Drycon-link-2::before {
    content: "\\eaa3";
}

.Drycon-linkedin::before {
    content: "\\eaa4";
}

.Drycon-list::before {
    content: "\\eaa5";
}

.Drycon-listing::before {
    content: "\\eaa6";
}

.Drycon-livingroom::before {
    content: "\\eaa7";
}

.Drycon-loader::before {
    content: "\\eaa8";
}

.Drycon-loading::before {
    content: "\\eaa9";
}

.Drycon-lock::before {
    content: "\\eaaa";
}

.Drycon-log-in::before {
    content: "\\eaab";
}

.Drycon-log-out::before {
    content: "\\eaac";
}

.Drycon-mail::before {
    content: "\\eaad";
}

.Drycon-man-1::before {
    content: "\\eaae";
}

.Drycon-man-2::before {
    content: "\\eaaf";
}

.Drycon-map::before {
    content: "\\eab0";
}

.Drycon-map-pin::before {
    content: "\\eab1";
}

.Drycon-maquette-360::before, .Drycon-model-360::before {
    content: "\\eab2";
}

.Drycon-maximize::before {
    content: "\\eab3";
}

.Drycon-maximize-2::before {
    content: "\\eab4";
}

.Drycon-media-kit::before {
    content: "\\eab5";
}

.Drycon-menu::before {
    content: "\\eab6";
}

.Drycon-menu-2::before {
    content: "\\eab7";
}

.Drycon-message-circle::before {
    content: "\\eab8";
}

.Drycon-message-square::before {
    content: "\\eab9";
}

.Drycon-messenger::before {
    content: "\\eaba";
}

.Drycon-mic::before {
    content: "\\eabb";
}

.Drycon-mic-off::before {
    content: "\\eabc";
}

.Drycon-minimize::before {
    content: "\\eabd";
}

.Drycon-minimize-2::before {
    content: "\\eabe";
}

.Drycon-minus::before {
    content: "\\eabf";
}

.Drycon-minus-circle::before {
    content: "\\eac0";
}

.Drycon-minus-square::before {
    content: "\\eac1";
}

.Drycon-monitor::before {
    content: "\\eac2";
}

.Drycon-moon::before {
    content: "\\eac3";
}

.Drycon-more-horizontal::before {
    content: "\\eac4";
}

.Drycon-more-vertical::before {
    content: "\\eac5";
}

.Drycon-move::before {
    content: "\\eac6";
}

.Drycon-music::before {
    content: "\\eac7";
}

.Drycon-navigation::before {
    content: "\\eac8";
}

.Drycon-navigation-2::before {
    content: "\\eac9";
}

.Drycon-newsletter::before {
    content: "\\eaca";
}

.Drycon-next::before, .Drycon-arrow-right-line::before {
    content: "\\eacb";
}

.Drycon-octagon::before {
    content: "\\eacc";
}

.Drycon-orbital::before {
    content: "\\eacd";
}

.Drycon-order::before {
    content: "\\eace";
}

.Drycon-outdoor::before, .Drycon-beach-umbrella::before {
    content: "\\eacf";
}

.Drycon-package::before {
    content: "\\ead0";
}

.Drycon-panorama-360::before {
    content: "\\ead1";
}

.Drycon-paperclip::before {
    content: "\\ead2";
}

.Drycon-pause::before {
    content: "\\ead3";
}

.Drycon-pause-circle::before {
    content: "\\ead4";
}

.Drycon-percent::before {
    content: "\\ead5";
}

.Drycon-phone::before {
    content: "\\ead6";
}

.Drycon-phone-call::before {
    content: "\\ead7";
}

.Drycon-phone-forwarded::before {
    content: "\\ead8";
}

.Drycon-phone-incoming::before {
    content: "\\ead9";
}

.Drycon-phone-missed::before {
    content: "\\eada";
}

.Drycon-phone-off::before {
    content: "\\eadb";
}

.Drycon-phone-outgoing::before {
    content: "\\eadc";
}

.Drycon-photo-editing::before {
    content: "\\eadd";
}

.Drycon-photo-shoot::before, .Drycon-photo-shooting::before {
    content: "\\eade";
}

.Drycon-pie-chart::before {
    content: "\\eadf";
}

.Drycon-pin::before {
    content: "\\eae0";
}

.Drycon-pin-filled::before {
    content: "\\eae1";
}

.Drycon-pinterest::before {
    content: "\\eae2";
}

.Drycon-plan-2d::before {
    content: "\\eae3";
}

.Drycon-plane::before {
    content: "\\eae4";
}

.Drycon-play::before {
    content: "\\eae5";
}

.Drycon-play-circle::before {
    content: "\\eae6";
}

.Drycon-plus::before {
    content: "\\eae7";
}

.Drycon-plus-circle::before {
    content: "\\eae8";
}

.Drycon-plus-square::before {
    content: "\\eae9";
}

.Drycon-pocket::before {
    content: "\\eaea";
}

.Drycon-power::before {
    content: "\\eaeb";
}

.Drycon-presentation::before {
    content: "\\eaec";
}

.Drycon-previous::before {
    content: "\\eaed";
}

.Drycon-price-tag::before {
    content: "\\eaee";
}

.Drycon-printer::before {
    content: "\\eaef";
}

.Drycon-radio::before {
    content: "\\eaf0";
}

.Drycon-refresh-ccw::before {
    content: "\\eaf1";
}

.Drycon-refresh-cw::before {
    content: "\\eaf2";
}

.Drycon-repeat::before {
    content: "\\eaf3";
}

.Drycon-reports::before {
    content: "\\eaf4";
}

.Drycon-restyling::before {
    content: "\\eaf5";
}

.Drycon-revo::before, .Drycon-revo-alt::before {
    content: "\\eaf6";
}

.Drycon-rewind::before {
    content: "\\eaf7";
}

.Drycon-room::before, .Drycon-bed::before {
    content: "\\eaf8";
}

.Drycon-rotate-ccw::before {
    content: "\\eaf9";
}

.Drycon-rotate-cw::before {
    content: "\\eafa";
}

.Drycon-save::before {
    content: "\\eafb";
}

.Drycon-scissors::before {
    content: "\\eafc";
}

.Drycon-search::before {
    content: "\\eafd";
}

.Drycon-send::before, .Drycon-paper-plane-horizontal::before {
    content: "\\eafe";
}

.Drycon-server::before {
    content: "\\eaff";
}

.Drycon-settings::before {
    content: "\\eb00";
}

.Drycon-share::before {
    content: "\\eb01";
}

.Drycon-share-2::before {
    content: "\\eb02";
}

.Drycon-shield::before {
    content: "\\eb03";
}

.Drycon-shoebox::before {
    content: "\\eb04";
}

.Drycon-shopping-cart::before {
    content: "\\eb05";
}

.Drycon-shuffle::before {
    content: "\\eb06";
}

.Drycon-side-a::before {
    content: "\\eb07";
}

.Drycon-side-b::before {
    content: "\\eb08";
}

.Drycon-sidebar::before {
    content: "\\eb09";
}

.Drycon-site-plan::before {
    content: "\\eb0a";
}

.Drycon-skip-back::before {
    content: "\\eb0b";
}

.Drycon-skip-forward::before {
    content: "\\eb0c";
}

.Drycon-slack::before {
    content: "\\eb0d";
}

.Drycon-slash::before {
    content: "\\eb0e";
}

.Drycon-sliders::before {
    content: "\\eb0f";
}

.Drycon-smartphone::before {
    content: "\\eb10";
}

.Drycon-social-media-kit::before {
    content: "\\eb11";
}

.Drycon-speaker::before {
    content: "\\eb12";
}

.Drycon-square::before {
    content: "\\eb13";
}

.Drycon-star::before {
    content: "\\eb14";
}

.Drycon-stop-circle::before {
    content: "\\eb15";
}

.Drycon-sun::before {
    content: "\\eb16";
}

.Drycon-sunpath::before {
    content: "\\eb17";
}

.Drycon-sunrise::before {
    content: "\\eb18";
}

.Drycon-sunset::before {
    content: "\\eb19";
}

.Drycon-surface::before {
    content: "\\eb1a";
}

.Drycon-tablet::before {
    content: "\\eb1b";
}

.Drycon-tag::before {
    content: "\\eb1c";
}

.Drycon-target::before {
    content: "\\eb1d";
}

.Drycon-thermometer::before {
    content: "\\eb1e";
}

.Drycon-thumbs-down::before {
    content: "\\eb1f";
}

.Drycon-thumbs-up::before {
    content: "\\eb20";
}

.Drycon-toggle-left::before {
    content: "\\eb21";
}

.Drycon-toggle-right::before {
    content: "\\eb22";
}

.Drycon-touch::before {
    content: "\\eb23";
}

.Drycon-tourama::before, .Drycon-tour-3d::before {
    content: "\\eb24";
}

.Drycon-trash::before {
    content: "\\eb25";
}

.Drycon-trash-2::before {
    content: "\\eb26";
}

.Drycon-trending-down::before {
    content: "\\eb27";
}

.Drycon-trending-up::before {
    content: "\\eb28";
}

.Drycon-triangle::before {
    content: "\\eb29";
}

.Drycon-tv::before {
    content: "\\eb2a";
}

.Drycon-twitter::before {
    content: "\\eb2b";
}

.Drycon-type::before {
    content: "\\eb2c";
}

.Drycon-umbrella::before {
    content: "\\eb2d";
}

.Drycon-underline::before {
    content: "\\eb2e";
}

.Drycon-unlock::before {
    content: "\\eb2f";
}

.Drycon-upload::before {
    content: "\\eb30";
}

.Drycon-upload-cloud::before {
    content: "\\eb31";
}

.Drycon-user::before {
    content: "\\eb32";
}

.Drycon-user-check::before {
    content: "\\eb33";
}

.Drycon-user-minus::before {
    content: "\\eb34";
}

.Drycon-user-plus::before {
    content: "\\eb35";
}

.Drycon-user-team::before {
    content: "\\eb36";
}

.Drycon-user-teammate::before {
    content: "\\eb37";
}

.Drycon-user-x::before {
    content: "\\eb38";
}

.Drycon-users::before {
    content: "\\eb39";
}

.Drycon-video::before {
    content: "\\eb3a";
}

.Drycon-video-animation::before {
    content: "\\eb3b";
}

.Drycon-video-off::before {
    content: "\\eb3c";
}

.Drycon-video-shoot::before {
    content: "\\eb3d";
}

.Drycon-view::before {
    content: "\\eb3e";
}

.Drycon-virtual-tour-exterior::before, .Drycon-exterior-tour-3d::before {
    content: "\\eb3f";
}

.Drycon-virtual-tour-exterior-1::before {
    content: "\\eb40";
}

.Drycon-virtual-tour-interior::before, .Drycon-interior-tour-3d::before {
    content: "\\eb41";
}

.Drycon-voicemail::before {
    content: "\\eb42";
}

.Drycon-volume::before {
    content: "\\eb43";
}

.Drycon-volume-1::before {
    content: "\\eb44";
}

.Drycon-volume-2::before {
    content: "\\eb45";
}

.Drycon-volume-x::before {
    content: "\\eb46";
}

.Drycon-vr-headset::before, .Drycon-vr::before {
    content: "\\eb47";
}

.Drycon-watch::before {
    content: "\\eb48";
}

.Drycon-website::before {
    content: "\\eb49";
}

.Drycon-wifi::before {
    content: "\\eb4a";
}

.Drycon-wifi-off::before {
    content: "\\eb4b";
}

.Drycon-wind::before {
    content: "\\eb4c";
}

.Drycon-x::before {
    content: "\\eb4d";
}

.Drycon-x-circle::before {
    content: "\\eb4e";
}

.Drycon-x-square::before {
    content: "\\eb4f";
}

.Drycon-zap::before {
    content: "\\eb50";
}

.Drycon-zen-style::before {
    content: "\\eb51";
}

.Drycon-zoom-in::before {
    content: "\\eb52";
}

.Drycon-zoom-out::before {
    content: "\\eb53";
}
`.replace(/#{version}/gm, version);
  }
    const mapping = {"activity":"activity","airplay":"airplay","alertCircle":"alert-circle","alertOctagon":"alert-octagon","alertTriangle":"alert-triangle","alignCenter":"align-center","alignJustify":"align-justify","alignLeft":"align-left","alignRight":"align-right","anchor":"anchor","aperture":"aperture","arrowDownLeft":"arrow-down-left","arrowDownRight":"arrow-down-right","arrowDown":"arrow-down","arrowLeft":"arrow-left","arrowRight":"arrow-right","arrowUpAndDown":"arrow-up-and-down","arrowUpLeft":"arrow-up-left","arrowUpRight":"arrow-up-right","arrowUp":"arrow-up","atSign":"at-sign","awaiting":"awaiting","award":"award","balcony":"balcony","barChart2":"bar-chart-2","barChart":"bar-chart","bathroom":"bathroom","batteryCharging":"battery-charging","battery":"battery","bedroom":"bedroom","bellOff":"bell-off","bell":"bell","billboard":"billboard","billing":"billing","bluetooth":"bluetooth","bold":"bold","book":"book","bookmark":"bookmark","box":"box","brandId":"brand-id","briefcase":"briefcase","briefing":"briefing","brochure":"brochure","budget":"budget","building":"building","calculator":"calculator","calendar":"calendar","cameraOff":"camera-off","camera":"camera","cast":"cast","checkCircle":"check-circle","checkSquare":"check-square","check":"check","chevronDown":"chevron-down","chevronLeft":"chevron-left","chevronRight":"chevron-right","chevronUp":"chevron-up","chevronsDown":"chevrons-down","chevronsLeft":"chevrons-left","chevronsRight":"chevrons-right","chevronsUp":"chevrons-up","chrome":"chrome","circle":"circle","classification":"classification","clipboard":"clipboard","clock":"clock","cloudDrizzle":"cloud-drizzle","cloudLightning":"cloud-lightning","cloudOff":"cloud-off","cloudRain":"cloud-rain","cloudSnow":"cloud-snow","cloud":"cloud","codepen":"codepen","coffee":"coffee","command":"command","commercialFloorplan":"commercial-floorplan","compare":"compare","compass":"compass","conversation":"conversation","copy":"copy","cornerDownLeft":"corner-down-left","cornerDownRight":"corner-down-right","cornerLeftDown":"corner-left-down","cornerLeftUp":"corner-left-up","cornerRightDown":"corner-right-down","cornerRightUp":"corner-right-up","cornerUpLeft":"corner-up-left","cornerUpRight":"corner-up-right","correctionRound":"correction-round","cosyStyle":"cosy-style","cpu":"cpu","creditCard":"credit-card","credit":"credit","crop":"crop","crosshair":"crosshair","delete":"delete","disc":"disc","downloadCloud":"download-cloud","download":"download","dragAndDrop":"drag-and-drop","drawbotics":"drawbotics","droneShoot":"drone-shoot","droplet":"droplet","edit2":"edit-2","edit3":"edit-3","edit":"edit","exterior3D":"exterior-3d","exteriorRestyling":"exterior-restyling","externalLink":"external-link","eyeOff":"eye-off","eye":"eye","facebook":"facebook","fastForward":"fast-forward","feather":"feather","fileMinus":"file-minus","filePlus":"file-plus","fileText":"file-text","file":"file","film":"film","filterFilled":"filter-filled","filter":"filter","fire":"fire","flag":"flag","flyer":"flyer","folder":"folder","furnishedOff":"furnished-off","furnished":"furnished","gallery":"gallery","garden":"garden","github":"github","gitlab":"gitlab","globe":"globe","grid":"grid","hallway":"hallway","hanger":"hanger","hash":"hash","headphones":"headphones","heartBroken":"heart-broken","heartFilled":"heart-filled","heart":"heart","helpCircle":"help-circle","home":"home","houseHigh":"house-high","houseLow":"house-low","house":"house","image":"image","inbox":"inbox","industrialStyle":"industrial-style","info":"info","insights":"insights","instagram":"instagram","interior3D":"interior-3d","invoice":"invoice","italic":"italic","key":"key","kitchen":"kitchen","landing":"landing","layers":"layers","layout":"layout","lifeBuoy":"life-buoy","lightBulb":"light-bulb","link2":"link-2","link":"link","linkedin":"linkedin","list":"list","listing":"listing","livingroom":"livingroom","loader":"loader","loading":"loading","lock":"lock","logIn":"log-in","logOut":"log-out","mail":"mail","man1":"man-1","man2":"man-2","mapPin":"map-pin","map":"map","maquette360":"maquette-360","maximize2":"maximize-2","maximize":"maximize","mediaKit":"media-kit","menu2":"menu-2","menu":"menu","messageCircle":"message-circle","messageSquare":"message-square","messenger":"messenger","micOff":"mic-off","mic":"mic","minimize2":"minimize-2","minimize":"minimize","minusCircle":"minus-circle","minusSquare":"minus-square","minus":"minus","monitor":"monitor","moon":"moon","moreHorizontal":"more-horizontal","moreVertical":"more-vertical","move":"move","music":"music","navigation2":"navigation-2","navigation":"navigation","newsletter":"newsletter","next":"next","octagon":"octagon","orbital":"orbital","order":"order","outdoor":"outdoor","package":"package","panorama360":"panorama-360","paperclip":"paperclip","pauseCircle":"pause-circle","pause":"pause","percent":"percent","phoneCall":"phone-call","phoneForwarded":"phone-forwarded","phoneIncoming":"phone-incoming","phoneMissed":"phone-missed","phoneOff":"phone-off","phoneOutgoing":"phone-outgoing","phone":"phone","photoEditing":"photo-editing","photoShoot":"photo-shoot","pieChart":"pie-chart","pinFilled":"pin-filled","pin":"pin","pinterest":"pinterest","plan2D":"plan-2d","plane":"plane","playCircle":"play-circle","play":"play","plusCircle":"plus-circle","plusSquare":"plus-square","plus":"plus","pocket":"pocket","power":"power","presentation":"presentation","previous":"previous","priceTag":"price-tag","printer":"printer","radio":"radio","refreshCcw":"refresh-ccw","refreshCw":"refresh-cw","repeat":"repeat","reports":"reports","restyling":"restyling","revo":"revo","rewind":"rewind","room":"room","rotateCcw":"rotate-ccw","rotateCw":"rotate-cw","save":"save","scissors":"scissors","search":"search","send":"send","server":"server","settings":"settings","share2":"share-2","share":"share","shield":"shield","shoebox":"shoebox","shoppingCart":"shopping-cart","shuffle":"shuffle","sideA":"side-a","sideB":"side-b","sidebar":"sidebar","sitePlan":"site-plan","skipBack":"skip-back","skipForward":"skip-forward","slack":"slack","slash":"slash","sliders":"sliders","smartphone":"smartphone","socialMediaKit":"social-media-kit","speaker":"speaker","square":"square","star":"star","stopCircle":"stop-circle","sun":"sun","sunpath":"sunpath","sunrise":"sunrise","sunset":"sunset","surface":"surface","tablet":"tablet","tag":"tag","target":"target","thermometer":"thermometer","thumbsDown":"thumbs-down","thumbsUp":"thumbs-up","toggleLeft":"toggle-left","toggleRight":"toggle-right","touch":"touch","tourama":"tourama","trash2":"trash-2","trash":"trash","trendingDown":"trending-down","trendingUp":"trending-up","triangle":"triangle","tv":"tv","twitter":"twitter","type":"type","umbrella":"umbrella","underline":"underline","unlock":"unlock","uploadCloud":"upload-cloud","upload":"upload","userCheck":"user-check","userMinus":"user-minus","userPlus":"user-plus","userTeam":"user-team","userTeammate":"user-teammate","userX":"user-x","user":"user","users":"users","videoAnimation":"video-animation","videoOff":"video-off","videoShoot":"video-shoot","video":"video","view":"view","virtualTourExterior1":"virtual-tour-exterior-1","virtualTourExterior":"virtual-tour-exterior","virtualTourInterior":"virtual-tour-interior","voicemail":"voicemail","volume1":"volume-1","volume2":"volume-2","volumeX":"volume-x","volume":"volume","vrHeadset":"vr-headset","watch":"watch","website":"website","wifiOff":"wifi-off","wifi":"wifi","wind":"wind","xCircle":"x-circle","xSquare":"x-square","x":"x","zap":"zap","zenStyle":"zen-style","zoomIn":"zoom-in","zoomOut":"zoom-out","arrowRightLine":"arrow-right-line","beachUmbrella":"beach-umbrella","bed":"bed","dataPoints":"data-points","moneyBag":"money-bag","paperPlaneHorizontal":"paper-plane-horizontal","droneShooting":"drone-shooting","exteriorTour3D":"exterior-tour-3d","interiorTour3D":"interior-tour-3d","landingPage":"landing-page","model360":"model-360","photoShooting":"photo-shooting","revoAlt":"revo-alt","tour3D":"tour-3d","vr":"vr"};

    module.exports = { generateIconStyles, mapping };
  